import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";

import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";

const names = {
  complaints: "Complaint.Complaints",
  list: "Complaint.ComplaintList",
  new: "Complaint.ComplaintNew",
  base: "Complaint.ComplaintBase",
  view: "Complaint.ComplaintView",
  edit: "Complaint.ComplaintEdit",
  investigations: "Complaint.ComplaintInvestigations",
  investigationEdit: "Complaint.ComplaintInvestigationEdit",
  investigationNew: "Complaint.ComplaintInvestigationNew",
  notes: "Complaint.ComplaintNotes",
  noteEdit: "Complaint.ComplaintNoteEdit",
  noteNew: "Complaint.ComplaintNoteNew",
  documents: "Complaint.ComplaintDocuments",
  documentEdit: "Complaint.ComplaintDocumentEdit",
  documentNew: "Complaint.ComplaintDocumentNew",
  audit: "Complaint.ComplaintAudit",
};

export { names as complaintRouteNames };

const complaintRoutes: RouterOptions["routes"] = [
  {
    path: "/complaints",
    name: names.complaints,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Complaints", lookupGroups: ["ComplaintType", "ComplaintStatus"] },
        component: () => import("@/views/complaint/ComplaintList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/complaint/ComplaintBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "New Complaint", isNew: true },
            component: () => import("@/views/complaint/ComplaintEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/complaint/ComplaintBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Complaint View" },
            component: () => import("@/views/complaint/ComplaintView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Complaint Edit", isForm: true },
            component: () => import("@/views/complaint/ComplaintEdit.vue"),
          },
          {
            path: "investigations",
            name: names.investigations,
            meta: { title: "Complaint Investigations" },
            component: () => import("@/views/complaint/ComplaintInvestigations.vue"),
          },
          {
            path: "investigations/:investigationId(\\d+)",
            name: names.investigationEdit,
            meta: { title: "Edit Complaint Investigation", isForm: true },
            component: () => import("@/views/complaint/ComplaintInvestigation.vue"),
          },
          {
            path: "investigations/new",
            name: names.investigationNew,
            meta: { title: "Create Complaint Investigation", isForm: true },
            component: () => import("@/views/complaint/ComplaintInvestigation.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Complaint Internal Notes" },
            component: {
              render: () => <EntityNotes idField="complaintId" routeNamePrefix="Complaint.ComplaintNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Complaint Internal Note", isForm: true },
            component: () => import("@/views/complaint/ComplaintNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Complaint Internal Note", isForm: true },
            component: () => import("@/views/complaint/ComplaintNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Complaint Documents" },
            component: {
              render: () => <EntityDocuments idField="complaintId" routeNamePrefix="Complaint.ComplaintDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Complaint Document", isForm: true },
            component: () => import("@/views/complaint/ComplaintDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Complaint Document", isForm: true },
            component: () => import("@/views/complaint/ComplaintDocuments.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Complaint Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Complaint" />,
            },
          },
          // {
          //   path: "affiliations",
          //   name: "ComplaintAffiliations",
          //   meta: { title: "Complaint Affiliations" },
          //   component: () => import("@/views/complaint/ComplaintAffiliations.vue"),
          // },
          // {
          //   path: "affiliations/:affiliationId(\\d+)",
          //   name: "ComplaintAffiliationEdit",
          //   meta: { title: "Edit Complaint Affiliation", isForm: true },
          //   component: () => import("@/views/complaint/ComplaintAffiliation.vue"),
          // },
          // {
          //   path: "affiliations/new",
          //   name: "ComplaintAffiliationNew",
          //   meta: { title: "Create Complaint Affiliation", isForm: true },
          //   component: () => import("@/views/complaint/ComplaintAffiliation.vue"),
          // },
        ],
      },
    ],
  },
];
export default complaintRoutes;
